module.exports = __webpack_public_path__ + "public/img/mianlogo.e127a82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mianlogo.jpg
// module id = 5h1l
// module chunks = 1